import { Container, Typography, Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import FeatureCard from './FeatureCard';
import AssignmentTurnedInOutlinedIcon from '@mui/icons-material/AssignmentTurnedInOutlined';
import MailOutlineOutlinedIcon from '@mui/icons-material/MailOutlineOutlined';
import Groups2OutlinedIcon from '@mui/icons-material/Groups2Outlined';
import PaymentOutlinedIcon from '@mui/icons-material/PaymentOutlined';
import SmartToyOutlinedIcon from '@mui/icons-material/SmartToyOutlined';
import PollOutlinedIcon from '@mui/icons-material/PollOutlined';

const SectionContainer = styled(Box)(({ theme }) => ({
  background: theme.palette.background.default,
  padding: theme.spacing(10, 0)
}));

const FeaturesGrid = styled(Box)(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))',
  gap: theme.spacing(4),
  marginTop: theme.spacing(6)
}));

const FeaturesSection: React.FC = () => {
  const features = [
    {
      icon: <AssignmentTurnedInOutlinedIcon />,
      title: "Smart Survey Creation",
      description: "Create engaging surveys in minutes! Design custom questions or let our AI instantly generate surveys based on your product specifications.",
      gradient: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)"
    },
    {
      icon: <MailOutlineOutlinedIcon />,
      title: "Multi-Channel Outreach",
      description: "Reach your real customers directly through email, SMS, WhatsApp, Telegram, or WeChat. Upload customer lists and send surveys seamlessly.",
      gradient: "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)"
    },
    {
      icon: <Groups2OutlinedIcon />,
      title: "Platform Integration",
      description: "Direct reviews where they matter most! Choose to funnel comments and ratings to Google, Facebook, Instagram, and other major platforms.",
      gradient: "linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)"
    },
    {
      icon: <PaymentOutlinedIcon />,
      title: "Instant Rewards",
      description: "Incentivize honest feedback with immediate cash payouts via UPI. You set the reward amounts and pay customers instantly for high-quality reviews and ratings.",
      gradient: "linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)"
    },
    {
      icon: <SmartToyOutlinedIcon />,
      title: "AI-Powered Reviews",
      description: "Our AI crafts perfect reviews from customer responses. Customers answer questions, AI generates enthusiastic summaries they can approve and post.",
      gradient: "linear-gradient(135deg, #fa709a 0%, #fee140 100%)"
    },
    {
      icon: <PollOutlinedIcon />,
      title: "Analytics Dashboard",
      description: "Gain valuable insights with comprehensive reports, real-time performance tracking, and detailed analytics for all your review campaigns.",
      gradient: "linear-gradient(135deg, #a8edea 0%, #fed6e3 100%)"
    }
  ];

  return (
    <SectionContainer>
      <Container maxWidth="lg">
        <Box textAlign="center" sx={{ mb: 8 }}>
          <Typography 
            variant="h2" 
            sx={{ 
              mb: 3,
              color: '#064E3B'
            }}
          >
            Powerful Features for Review Success
          </Typography>
          
          <Typography 
            variant="h6" 
            sx={{ 
              color: 'text.secondary', 
              maxWidth: 600, 
              mx: 'auto',
              lineHeight: 1.6
            }}
          >
            Everything you need to transform customer feedback into powerful social proof 
            and boost your online reputation across all platforms.
          </Typography>
        </Box>

        <FeaturesGrid>
          {features.map((feature, index) => (
            <FeatureCard
              key={index}
              icon={feature.icon}
              title={feature.title}
              description={feature.description}
              gradient={feature.gradient}
            />
          ))}
        </FeaturesGrid>
      </Container>
    </SectionContainer>
  );
};

export default FeaturesSection;